import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import DocumentsResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/DocumentService/DocumentResponse";
import DocumentsUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/DocumentService/DocumentUpdateRequest";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import DocumentsTranslateModel from "@/models/documents/documentsTranslateModel"

export default class CreateDocumentsViewModel {
    id?: number = null;
	translations: Array<DocumentsTranslateModel> = null;
    initLanguages(langs: string[]) {
        this.translations = (langs || []).map(x => new DocumentsTranslateModel({
            langCode: x
        }));
    }
	toServerModel(): DocumentsUpdateRequest {
		const req = new DocumentsUpdateRequest({
			Id: this.id,
			Translations: this.translations.map(x=>x.toServerModel())
		});
		
		return req;
	}
	fromServerModel(model: DocumentsResponse) {
		this.id = model.Id;
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.text = serverTranslation.Text;
			}
		});
	}
}